import React from 'react';
import { Link } from 'react-router-dom';

export default function PageHeader({ title, subtitle, breadcrumbs = [] }) {
  return (
    <div className="bg-[#0f2b48] text-white py-12 sm:py-16 border-b border-slate-700/60 relative overflow-hidden">
      {/* Subtle modern background texture */}
      <div className="absolute inset-0 bg-radial from-sky-900/30 via-transparent to-transparent pointer-events-none" />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {breadcrumbs && breadcrumbs.length > 0 && (
          <nav aria-label="Brødkrummer" className="mb-4">
            <ol className="flex items-center space-x-2 text-xs text-slate-300">
              <li>
                <Link to="/" className="hover:text-white transition-colors">
                  Forside
                </Link>
              </li>
              {breadcrumbs.map((crumb, idx) => (
                <li key={idx} className="flex items-center space-x-2">
                  <span className="text-slate-500">/</span>
                  {crumb.path ? (
                    <Link to={crumb.path} className="hover:text-white transition-colors">
                      {crumb.label}
                    </Link>
                  ) : (
                    <span className="text-sky-300 font-medium">{crumb.label}</span>
                  )}
                </li>
              ))}
            </ol>
          </nav>
        )}

        <div className="max-w-3xl">
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-white mb-3">
            {title}
          </h1>
          {subtitle && (
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed">
              {subtitle}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
